const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://8x1bjinrxe.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://2hgy67acd2.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.staging.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://fjbp8skumh.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;
